// extracted by mini-css-extract-plugin
export var arrowButton = "Hero-module--arrowButton--4S41O";
export var button = "Hero-module--button--ehAc6";
export var content = "Hero-module--content--Z1PM0";
export var title = "Hero-module--title--5vPR-";
export var wrapper = "Hero-module--wrapper--f6rlZ";